module.exports = __webpack_public_path__ + "img/x.bb8a528f.svg";